<template>
  <div>
    <div v-if="loading" v-loading="loading" class="loading"></div>
    <template v-else>
      <div>
        <div class="ra-page--section">
          <el-row type="flex" class="flex-wrap" :gutter="30">
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <verifications-count />
              <recent-verifications />
            </el-col>
            <el-col :md="12" :lg="12">
              <verifications-by-type />
            </el-col>
          </el-row>
        </div>
        <div class="ra-page--section">
          <el-row type="flex" class="flex-wrap" :gutter="20">
            <el-col :md="24" :lg="24">
              <verifications-chart />
            </el-col>
          </el-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import RecentVerifications from "@/components/Products/VerifyIdentity/Verifications/RecentVerifications";
import VerificationsByType from "@/components/Products/VerifyIdentity/Verifications/VerificationsByType";
import VerificationsChart from "@/components/Products/VerifyIdentity/Verifications/VerificationsChart";
import VerificationsCount from "@/components/Products/VerifyIdentity/Verifications/VerificationsCount";
import apiConstants from "@/apiConstants";
import { userData } from "@/lib/utils";

export default {
  name: "VerifyIdentity",
  components: {
    VerificationsCount,
    VerificationsChart,
    RecentVerifications,
    VerificationsByType
  },
  data() {
    return {
      loading: false,
      onboarding: false,
      totalRequests: 0
    };
  },
  created() {
    this.summaryStats();
  },
  methods: {
    summaryStats() {
      this.loading = true;
      const apiUrl = "services/logs";
      const aggs = JSON.stringify([
        {
          field: "id",
          func: "count",
          alias: "total_count"
        }
      ]);
      const params = `aggs=${aggs}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          const resData = response.data;
          const { email } = userData().user;

          if (email.includes("ismail")) {
            this.onboarding = true;
            this.loading = false;
          } else if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            const total = resData.list.length && resData.list[0].total_count;
            this.totalRequests = total ? total : 0;
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.loading {
  height: 200px;
  background: #fff;
  border-radius: 10px;
}
</style>
